import { lazy } from 'react'

export const Squats = lazy(() => import('./Squats'))
